import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';
import { Formik, Field, Form as FormikForm } from 'formik';

import HorizontalRangeField from 'components/new_ui/Form/HorizontalRangeField';
import formatCurrency from 'components/utils/formatCurrency';

function removeDuplicates(array) {
  const seen = new Set();
  return array.filter((item) => {
    const k = item.attributes.title;
    return seen.has(k) ? false : seen.add(k);
  });
}

export default function CalculatorPlans({ templates }) {
  const getMax = (templateTitle) => {
    switch (templateTitle) {
      case 'TI Platform':
        return 5000;
      case 'TI On-Demand':
        return 500;
      default:
        return 100;
    }
  };

  const filterTemplates = removeDuplicates(templates);

  const getPrice = (template, countMembers, withProcent) => {
    const priceItem = template.attributes.price.find((item) => item.currency === 'USD');
    const price = priceItem && !template.attributes.is_free ? priceItem.priceNumber : 0;
    const totalPrice = price * countMembers;

    return totalPrice * (withProcent ? 0.1 : 1) * 12;
  };

  const totalPrice = (values) => filterTemplates.map(
    (template) => getPrice(template, values[template.attributes.title], true),
  ).reduce((accumulator, currentValue) => accumulator + currentValue, 0);

  return (
    <Formik
      initialValues={{
        'TI Platform': 250,
        'TI On-Demand': 20,
      }}
    >
      {({ values }) => (
        <FormikForm className="form-with-counter" noValidate="">
          <Row>
            <Col md={{ span: 10, offset: 1 }} lg={{ span: 8, offset: 2 }}>
              {filterTemplates.map((template) => (
                <div className="mb-5" key={template.id}>
                  <HorizontalRangeField
                    type="range"
                    min="1"
                    max={getMax(template.attributes.title)}
                    name={template.attributes.title}
                    label={template.attributes.title}
                    hint={`Set the number of employees for ${template.attributes.title} Plan`}
                  />

                  <div className="d-md-flex justify-content-between align-items-center fs-4">
                    <div className="d-flex align-items-center">
                      Employees:
                      <Field
                        autoComplete="off"
                        className="form-control ms-2"
                        style={{ width: '100px', display: 'inline' }}
                        type="number"
                        min="1"
                        max={getMax(template.attributes.title)}
                        name={template.attributes.title}
                      />
                    </div>

                    <div className="mt-2 mt-md-0">
                      Contract Value:
                      {template.attributes.is_free && ' Free'}
                      {!template.attributes.is_free && (
                        ` $${formatCurrency(getPrice(template, values[template.attributes.title], false), '')}`
                      )}
                    </div>
                  </div>
                </div>
              ))}

              <div className="text-center">
                <p>Based on the information provided your estimated annual commision (10%) is:</p>

                <div className="fs-1 text-primary">
                  $
                  {formatCurrency(totalPrice(values), '')}
                </div>
              </div>
            </Col>
          </Row>
        </FormikForm>
      )}
    </Formik>
  );
}

CalculatorPlans.propTypes = {
  templates: PropTypes.arrayOf(PropTypes.object).isRequired,
};
